export default "__VITE_ASSET__BsTg_NnT__"